import { z } from 'zod';
export const DASHBOARD_VIEW_TAGS = [
    'PENDING_DRAI',
    'ACTIVE_CASE',
    'ACTIVE_EYE',
    'ACTIVE_TISSUE',
    'ACTIVE_RECOVERY',
];
export const DashboardViewTag = z.enum(DASHBOARD_VIEW_TAGS);
export const DASHBOARD_PRIORITIES = ['A', 'B', 'C', 'D', 'E', 'F'];
export const DashboardPriority = z.enum(DASHBOARD_PRIORITIES);
export const DashboardCase = z.object({
    caseId: z.number(),
    donorId: z.string().nullable(),
    din: z.string().nullable(),
    donorName: z.string(),
    registryStatus: z.boolean().nullable(),
    registryVerified: z.enum(['Y', 'N']).nullable(),
    funeralHome: z.string().nullable(),
    caseType: z.string().nullable(),
    coordinatingAgency: z.string().nullable(),
    caseStatus: z.string().nullable(),
    meStatus: z.enum(['Yes', 'No', 'Pending']),
    autopsyStatus: z.string().nullable(),
    referringOrganization: z.string().nullable(),
    region: z.string().nullable(),
    referringOrganizationActive: z.boolean().nullable(),
    tissuePartner: z.string(),
    gender: z.string().nullable(),
    deathDate: z.string().nullable(),
    deathDateTimezone: z.string().nullable(),
    age: z.string().nullable(),
    draiTimeout: z.string(),
    dispatchIntent: z.string().nullable(),
    dispatchLocation: z.string().nullable(),
    deathToPreservation: z.string().nullable(),
    shared: z.enum(['Y', 'N', 'Unknown']),
    partnerId: z.string(),
    referralPartners: z.string().nullable(),
    priority: DashboardPriority.nullable(),
    priorityTooltip: z.string().nullable(),
    priorityManuallyUpdated: z.boolean(),
    expiration: z.string().nullable(),
    expirationTimezone: z.string().nullable(),
    cellCounts: z.array(z.string()),
    serologyCompleted: z.boolean(),
    draiCompleted: z.boolean(),
    etrCompleted: z.string().nullable(),
    abo: z.string(),
    htlv: z.boolean(),
    serology: z.boolean(),
    intent: z.string().nullable(),
    activeCaseIntent: z.string().nullable(),
    assignedReferralCoordinator: z.string(),
    assignedMedicalReview: z.string(),
    assignedRecoveryTech: z.string(),
    familyStatus: z.string().nullable(),
    nextStep: z.string().nullable(),
    bodyHoldDate: z.coerce.date().nullable(),
    bodyHoldDateTimezone: z.string().nullable(),
    medReviewNotes: z.string(),
    lastCaseNote: z.string().nullable(),
    viewTags: z.array(DashboardViewTag),
});
export const DashboardViewTagSocketEvent = z.object({
    type: z.enum(['viewTag.add', 'viewTag.remove']),
    caseId: z.number(),
    viewTag: DashboardViewTag,
});
export const DashboardCaseChanges = DashboardCase.omit({
    caseId: true,
})
    .partial()
    .refine((changes) => Object.keys(changes).length > 0, {
    message: 'Dashboard changes must include at least one field',
});
export const DashboardPatchSocketEvent = z.object({
    caseId: z.number(),
    changes: DashboardCaseChanges,
});
export const DashboardSocketEvent = z.union([DashboardViewTagSocketEvent, DashboardPatchSocketEvent]);
